import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, Users } from "lucide-react";
import { EmptyState } from "../../components/shared/EmptyState";
import { api } from "../../lib/api";

export default function ClientsPage() {
  const [customers, setCustomers] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.get("/admin/customers").then((r) => setCustomers(r.data)).catch(() => setCustomers([]));
  }, []);

  if (!customers) return <div className="py-16 text-center font-heading text-deepgreen" data-testid="clients-loading">Chargement…</div>;

  const filtered = customers.filter((c) =>
    `${c.first_name} ${c.last_name} ${c.email}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div data-testid="admin-clients-page">
      <p className="overline-ae">B11 — Clients</p>
      <h1 className="mt-1 font-heading text-2xl sm:text-3xl text-deepgreen">Clients</h1>
      <p className="mt-1 text-sm text-muted-foreground">Fiche centralisée par client — chaque événement reste clairement séparé.</p>

      <div className="card-ae mt-6">
        <div className="border-b border-border px-5 py-4">
          <div className="relative max-w-md">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <input className="input-ae !pl-9" placeholder="Rechercher un client…" value={search} onChange={(e) => setSearch(e.target.value)} data-testid="clients-search" />
          </div>
        </div>
        {filtered.length === 0 ? (
          <div className="p-5"><EmptyState icon={Users} title="Aucun client">Les comptes clients créés apparaîtront ici.</EmptyState></div>
        ) : (
          <ul className="divide-y divide-border" data-testid="clients-list">
            {filtered.map((c) => (
              <li key={c.id}>
                <Link to={`/admin/clients/${c.id}`} className="flex items-center gap-4 px-5 py-4 transition-colors hover:bg-cream/60" data-testid={`client-row-${c.id}`}>
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-sage-light font-heading text-sm font-semibold text-deepgreen">
                    {(c.first_name?.[0] || "?")}{(c.last_name?.[0] || "")}
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-semibold text-deepgreen">{c.first_name} {c.last_name}</p>
                    <p className="text-xs text-muted-foreground">{c.email}</p>
                  </div>
                  {c.test_account && <span className="rounded-full bg-gold-light px-2.5 py-1 text-[10px] font-bold text-deepgreen">TEST</span>}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
